module.exports = __webpack_public_path__ + "img/dots_rdb_3.01657546.png";